import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import LazyLoadImage from 'components/LazyLoad/Image';

import styles from './styles.module.scss';

const GridImage = ({ image, isLazySlider }) => {
	const renderImage = () => (
		<div className={styles.GridImage__Inner}>
			<img
				className={cx(styles.GridImage__Image, isLazySlider && 'swiper-lazy')}
				src={image}
				alt=""
			/>
		</div>
	);

	return isLazySlider ? (
		<>{renderImage()}</>
	) : (
		<LazyLoadImage imageSrc={image}>{renderImage()}</LazyLoadImage>
	);
};

GridImage.propTypes = {
	image: PropTypes.string.isRequired,
	isLazySlider: PropTypes.bool
};

export default GridImage;
